import {IApiBusinessProfileProto, space} from "../../../compiled";
import {useMemo} from "react";
import IServiceProto = space.kenko.proto.IServiceProto;
import {providerOffersService} from "../../../util/ProviderUtil";

type Props = {
  business: IApiBusinessProfileProto | undefined,
  practitionerFilter: string | null | undefined,
  onSelect: (service: IServiceProto) => void;
}

export const ChooseService = (props: Props) => {

  const getServicesByCategory = useMemo(() => {

    const services = new Map<string, IServiceProto[]>();

    props.business?.practice?.services?.filter(s => !s.archived).forEach(service => {

      if (props.practitionerFilter && !providerOffersService(service, props.practitionerFilter)) {
        // Service not offered by this practitioner.
        return;
      }

      const category = service.category || '';

      // Create a new array or append to existing (multimap behavior)
      if (!services.has(category)) {
        services.set(category, [service]);
      } else {
        // @ts-ignore
        services.get(category).push(service);
      }
    });

    return services;

  }, [props.business, props.practitionerFilter])

  return <div style={{display: 'flex', flexDirection: "column", textAlign: 'start'}}>
    <h3>Select Service Type</h3>

    {Array.from(getServicesByCategory).map(([category, services]) => {
      return <>
        <h4>{category}</h4>
        {services.map(service => {
          return <button key={'serv' + service.sku} className={'BookingOverlaySelectable'} onClick={() => {
            props.onSelect(service)
          }}>
            <div style={{display: 'flex', gap: 10, alignItems: 'center'}}>
              {service.isVirtual && <div className={'VirtualBadge'}>Virtual</div>}
              <div>
                <div><b>{service.name} ({service.lengthMinutes} min)</b></div>
                <div>{service.description}</div>
              </div>
            </div>
          </button>
        })}
      </>
    })}
  </div>
}